'use strict';
import React from 'react';
import flux from 'utils/flux';
import store from 'store';
import _cloneDeep from 'lodash/lang/cloneDeep';

var MediaHeaderSearch = React.createClass({

    displayName: 'MediaHeaderSearch',

    mixins: [],

    propTypes: {
        query: React.PropTypes.string,
        mediaStore: React.PropTypes.object
    },

    contextTypes: {
        router: React.PropTypes.func.isRequired
    },

    getInitialState() {
        return {
            search: ''
        };
    },

    componentWillReceiveProps(nextProps) {
        this.setState({
            search: nextProps.query
        });
    },

    search(e) {
        e.preventDefault();
        var query = _cloneDeep(this.context.router.getCurrentQuery());
        if (this.state.search !== '') {
            query.search = this.state.search;
        } else {
            delete query.search;
            flux.getActions('media').clearSearch();
        }
        if (query.search && query.search !== '') {
            const pagination_amount = store.get('pagination_amount')
            if (!query.page) {
              query.page = 1;
            }
            if (!query.per_page) {
                query.per_page = pagination_amount;
            }
        }
        this.context.router.transitionTo('listing', null, query);
    },

    onChange(e) {
        e.preventDefault();
        this.setState({search: e.target.value});
    },

    render() {
        const { router } = this.context;
        const route = router.getRouteAtDepth(1);
        const isLanding = route && 'landing-page' === route.name;
        const placeholder = isLanding ? flux.t('searchterm_landing') : flux.t('searchterm');
        return (
            <div className="headerbar__search">
                <form onSubmit={this.search}>
                    <input onChange={this.onChange} value={this.state.search} type="text" name="search" placeholder={placeholder} />
                    <button className="search__button" type="submit">
                        <i className="search" />
                    </button>
                </form>
            </div>
        );
    }
});

module.exports = MediaHeaderSearch;



// WEBPACK FOOTER //
// ./app/components/headerBar/headerSearch.jsx